/* eslint-disable @typescript-eslint/no-require-imports */
import { addSharedLocales } from 'fourwaves-shared';

export default addSharedLocales('fr', {
  countries: require('fourwaves-shared/src/core/countries.fr.json'),
  provinces: require('fourwaves-shared/src/core/provinces.fr.json'),
  currencies: require('fourwaves-shared/src/core/currencies.fr.json'),
  fourwaves_badge: {
    title: 'Propulsé par',
    link: 'https://fourwaves.com/fr/?utm_source=logo&utm_medium=eventwebsite',
  },
  footer: {
    title: 'Organisez votre prochain événement avec Fourwaves.',
    cta_button: 'En savoir plus',
    cta_button_link: 'https://fourwaves.com/fr/?utm_source=footer&utm_medium=eventwebsite',
    copyright: 'tous droits réservés',
    terms_of_service: `Conditions d'utilisation`,
    terms_of_service_link: 'https://fourwaves.com/fr/conditions-d-utilisation/',
    privacy_policy: 'Politique de confidentialité',
    privacy_policy_link: 'https://fourwaves.com/fr/politique-de-vie-privee/',
  },
  navigation: {
    header_event: 'Cet événement',
    login: 'Connexion',
    register_form: 'Mon inscription',
    submission_form: 'Mon résumé',
    organizer_panel: 'Panneau organisateur',
    account: 'Compte',
    registrations: 'Mes inscriptions',
    submissions: 'Mes soumissions',
    transactions: 'Mes transactions',
    events: 'Mes événements',
    organizations: 'Mes organisations',
    more: 'Plus',
    burger: 'Menu',
    aria_nav: 'Navigation principale',
    aria_burger: 'Basculer le menu',
    lang_switch: 'Parcourir en',
    edit_event: 'Modifier',
  },
  live_banner: {
    title: "L'événement a lieu aujourd'hui",
    button: "Accéder à l'événement",
  },
  file_upload: {
    title: 'Titre',
  },
  form: {
    breadcrumb: {
      form: 'Formulaire',
      billing: 'Paiement',
      confirmation: 'Confirmation',
      submission_confirmation_header: 'Soumission complétée',
      registration_confirmation_header: 'Inscription complétée',
      waitlist_confirmation: `Vous êtes sur la liste d'attente`,
    },
    summary: {
      submit: 'Soumettre',
      additional_info_content: 'Pour toute question, contactez',
      coupon_code: 'Code',
      payment: {
        confirm_and_pay: 'Continuer au paiement',
        pay_now: 'Payer maintenant',
        payment_notice: 'Paiement sécurisé par',
        total: 'Total',
        sub_total: 'Sous-total',
        billing_title: 'Adresse de facturation',
        billing_info: 'Informations de facturation',
        email_notice: '(La facture sera envoyée à cette adresse)',
        payment: 'Paiement',
        payment_method_title: 'Méthode de paiement',
        missing_payment_methods: "Aucune méthode de paiement n'a été configurée pour cet événement.",
        coupon_code: 'Code promo',
        remove_coupon_code: 'Supprimer le code promo',
        methods: {
          credit_card: 'Carte de crédit',
          void: 'Ignorer le paiement',
          deferred: 'Paiement par facture',
          forward_payment: 'Transmettre le paiement',
        },
        gst: 'TPS',
        hst: 'TVH',
        qst: 'TVQ',
        vat: 'TVA',
        pst: 'TVP',
        vat_number: 'Numéro de TVA',
        tax_rules: {
          none: 'Aucune taxe',
          qstallgstall: 'TVQ 9.975% et TPS 5%',
          qstquebecgstcanada: 'TVQ 9.975% et TPS 5% au Québec, TPS 5% reste du Canada',
          qstquebecgstall: 'TVQ 9.975% et TPS 5% au Québec, TPS 5% reste du monde',
          gstall: 'TPS 5%',
          gst5canada: 'TPS 5% au Canada',
          gst5pst7: 'TPS 5% et TVP 7%',
          gst10all: 'TPS 10%',
          gst15all: 'TPS 15%',
          hst13all: 'TVH 13%',
          hst15all: 'TVH 15%',
          hst13canada: 'TVH 13% au Canada',
          vat77all: 'TVA 7.7%',
          vat10all: 'TVA 10%',
          vat20all: 'TVA 20%',
          vat25all: 'TVA 25%',
          vat25denmark: 'TVA 25% au Danemark',
          vat19germany: 'TVA 19% en Allemagne',
          vat19europe: 'TVA 19% en Europe',
          vat0: 'TVA 0%',
          vatreversecharge0: 'TVA autoliquidation 0%',
        },
      },
      discrepancies_notice: "Le prix d'un article a changé. Veuillez valider les informations ci-haut.",
      edit: 'Sauvegarder le formulaire',
      ongoing_upload_notice: 'Merci de patienter pendant le téléchargement des fichiers.',
      blocked_edit: 'La modification de ce formulaire est impossible.',
      join_waitlist: "Joindre la liste d'attente",
      mandatory_warning_title: 'Inscription obligatoire',
      mandatory_warning_message: 'Assurez-vous de vous inscrire avec la même adresse courriel avant de soumettre.',
    },
    confirmation: {
      receipt_title: 'Votre facture',
      receipt_number: 'Numéro de facture',
      receipt_action: 'Télécharger le PDF',
    },
    edit_email: `En changeant l'adresse courriel, le formulaire est transféré au nouvel utilisateur ({newEmail}), qui recevra une notification par courriel. Le propriétaire d'origine ({oldEmail}) ne pourra plus voir ni éditer le formulaire. Voulez-vous continuer?`,
    edit_success: 'Le formulaire a été sauvegardé avec succès.',
  },
  registration: {
    subtitle: `La date limite d'inscription est le`,
    subtitle_not_started: 'Les inscriptions débutent le',
    subtitle_closed: 'Les inscriptions ont terminé le',
    waitlist: `Liste d'attente`,
    summary: `Résumé d'inscription`,
    confirmation: {
      title: 'Votre formulaire a été soumis avec succès',
      subtitle: `Cliquez sur le lien dans le courriel de confirmation envoyé à <span class='util--main-color'>{email}</span> pour activer votre compte. Connectez-vous pour accéder à vos formulaires et à certaines fonctionnalités le jour de l'événement.`,
    },
    registration_closed: {
      not_started: 'Veuillez revenir le',
      logged_out_text: '<a href="{url}">Connectez-vous</a> pour accéder à vos inscriptions.',
      logged_in_text: `Allez à votre compte pour accéder à <a href="{url}">vos inscriptions</a>.`,
    },
    state_EventHasEnded: `L'événement est clôturé.`,
    state_FullWithWaitingList: `Le nombre maximum de participants a été atteint. Remplissez le formulaire ci-dessous pour être inscrit sur la liste d'attente.`,
    state_Full: 'Limite de participants atteinte.',
    state_PeriodHasEnded: `La période d'inscription est terminée.`,
    state_PeriodDidNotStart: `La période d'inscription n'est pas commencée.`,
  },
  submission: {
    subtitle: 'La date limite de soumission est le',
    subtitle_not_started: 'Les soumissions débutent le',
    subtitle_closed: 'Les soumissions ont terminé le',
    submission_period_finished: 'La période de soumission est fermée.',
    confirmation: {
      title: 'Votre formulaire a été soumis avec succès',
      subtitle: `Cliquez sur le lien dans le courriel de confirmation envoyé à <span class='util--main-color'>{email}</span> pour activer votre compte. Connectez-vous pour accéder à vos formulaires et à certaines fonctionnalités le jour de l'événement.`,
    },
    submission_closed: {
      not_started: 'Veuillez revenir le',
      logged_out_text: '<a href="{url}">Connectez-vous</a> pour accéder à vos soumissions.',
      logged_in_text: `Allez à votre compte pour accéder à <a href="{url}">vos soumissions</a>.`,
    },
    state_EventHasEnded: `L'événement est clôturé.`,
    state_FullWithWaitingList: `Le nombre maximum de soumissions a été atteint. Remplissez le formulaire ci-dessous pour être inscrit sur la liste d'attente.`,
    state_Full: 'Limite de soumissions atteinte.',
    state_PeriodHasEnded: 'La période de soumission est terminée.',
    state_PeriodDidNotStart: `La période de soumission n'est pas commencée.`,
  },
  validation: {
    required: 'Ce champ est requis.',
    is: 'Ce champ doit être identique.',
    email: 'Veuillez saisir un courriel valide.',
    rte_max_length: `Vous avez entré trop de mots. Veuillez raccourcir l'entrée.`,
  },
  global: {
    apply: 'Appliquer',
    show_more: 'Afficher plus',
    save: 'Enregistrer',
    cancel: 'Annuler',
    words: 'Mots',
    edit: 'Modifier',
    until: "jusqu'au",
    first_name: 'Prénom',
    last_name: 'Nom',
    name: 'Nom',
    email: 'Courriel',
    company: 'Compagnie / Organisation',
    add: 'Ajouter',
    unavailable: 'Non disponible',
    please_select: 'Veuillez sélectionner...',
    by: 'par',
    to: 'Destinataire',
    subject: 'Sujet',
    body: 'Message',
    fw_statement_descriptor: 'Votre relevé de carte de crédit indiquera une transaction provenant de FOURWAVES EVENTS.',
    address: {
      street: 'Adresse',
      city: 'Ville',
      country: 'Pays',
      province: 'Province/État',
      postal: 'Code postal ou ZIP',
    },
    payment_methods: {
      stripe: 'En ligne (Stripe)',
      paysafe: 'En ligne (Paysafe)',
      alipay: 'En ligne (Alipay)',
      bypass: 'Ignorer',
      invoicing: 'Facturation',
      publisoft: 'En ligne (Publisoft)',
      void: 'Annulé',
      touchnet: 'TouchNet',
      globalpayments: 'Global Payments',
      moneris: 'Moneris',
      paypal: 'PayPal',
    },
    transaction_status: {
      refund: {
        concluded: 'Remboursé',
        pending: 'En attente',
        canceled: 'Annulé',
      },
      charge: {
        concluded: 'Payé',
        pending: 'En attente',
        canceled: 'Annulé',
      },
    },
    review_status: {
      title: 'À évaluer',
      unassigned: 'Non attribué',
      pending: 'En attente',
      conflictofinterest: "Conflit d'intérêts",
      completed: 'Complété',
    },
    transaction_type: {
      refund: 'Remboursement',
      payment: 'Paiement',
    },
    event_information: "Informations de l'événement",
    home: 'Accueil',
    password: 'Mot de passe',
    login_success: 'Vous êtes connecté avec succès',
    no_location: 'Aucun emplacement',
    online_event: 'Événement en ligne',
    hybrid_event: 'Événement hybride',
    loading: 'Chargement des données...',
    pagination_prev: 'Précédent',
    pagination_next: 'Suivant',
    pagination_display: 'Afficher',
    forgot: 'Mot de passe oublié ou Activez votre compte',
    send: 'Envoyer',
    forgot_password: 'Mot de passe oublié?',
    forgot_password_success: 'Veuillez vérifier votre boîte de réception.',
    download: 'Télécharger',
    read_more: 'Lire plus',
    close: 'Fermer',
    from: 'de',
    learn_more: 'En savoir plus',
    clear_filters: 'Effacer les filtres',
    filters: 'Filtres',
    hide_filters: 'Cacher les filtres',
    select_default_placeholder: 'Sélectionner une option',
  },
  event_details: {
    location: `Lieu de l'événement`,
    registration_period: `Période d'inscription`,
    submission_period: 'Période de soumission',
    contact: 'Contactez-nous',
    contact_message: `Pour toute question sur l'événement, veuillez contacter:`,
  },
  participants: {
    participant: 'Aucun participant | {count} participant | {count} participants',
    message: `Cette page liste les participants inscrits à l'événement.`,
    no_results: `Il n'y a aucun participant à montrer`,
    search_placeholder: 'Rechercher',
    photo_of: 'Photo de ',
    registration_deadline_is: `La date limite pour s'inscrire est le`,
    bookmark_filter: 'Mes connexions',
    online_filter: 'En ligne',
    back_to_list: 'Retour',
    placeholder_text: 'Aucune information disponible.',
    listing_options: {
      alphabetical: 'A - Z',
    },
  },
  poster_hall: {
    title: 'Salle des affiches',
  },
  abstracts: {
    upvote: '0 votes | 1 vote | {count} votes',
    bookmark: 'Favori',
    bookmarked: 'Favori',
    bookmark_filter: 'Mes favoris',
    comment: '0 commentaires | 1 commentaire | {count} commentaires',
    schedule_filter: 'Session',
    schedule_filter_all: 'Voir tous',
    search_placeholder: 'Rechercher',
    total_count: 'Aucune présentation | {count} présentation | {count} présentations',
    no_presentations: 'Aucune présentation.',
    abstract: 'Détails',
    figures: 'Figures',
    slides: 'Diapositives',
    poster: 'Affiche',
    video: 'Vidéo',
    back_to_list: 'Retour à la liste',
    in_discussion: 'en discussion',
    call_presenter: 'Appeler le présentateur',
    join: 'Rejoindre',
    join_conversation: 'Rejoindre la conversation',
    enter_conversation: 'Entrer dans la salle de conversation',
    listen_conversation: 'Écouter la conversation vidéo',
    open_for_discussion: 'Ouvert pour discussion',
    presented_by: 'Présenté par ',
    by: 'Par ',
    sign_in_to_contact: 'Se connecter pour contacter',
    contact: 'Contacter',
    contact_presenter_modal: {
      title: 'Contacter le présentateur',
      send_email: 'Envoyer le courriel',
      success_message: 'Courriel envoyé.',
    },
    login_cta: {
      join_conversation: `L'événement est en cours. Rejoignez la conversation.`,
      need_to_signed: 'Vous devez être connecté pour participer.',
      sign_in: 'Connexion',
      already_registered: 'Déjà enregistré?',
      activate_your_account: 'Activer votre compte',
      not_registered: 'Besoin de vous inscrire?',
      open_registration: 'Inscrivez-vous maintenant',
    },
    schedule_presentations: {
      title: 'Programmé dans {count} session | Programmé dans {count} sessions',
      description: "* Toutes les heures indiquées sont basées sur l'heure",
    },
    other_information: 'Autres informations',
    listing_options: {
      numerical: '1 - 9',
      alphabetical: 'A - Z',
      upvotes: 'Votes',
    },
    presenting_now: 'Présentation en cours',
    picture_layout: 'Vue avec mode image',
    list_layout: 'Vue en mode liste',
    enable_laser: 'Activer le pointeur laser',
    disable_laser: 'Désactiver le pointeur laser',
    follow: 'Suivre',
    following: 'En suivi de',
    preparing_poster: `Chargement de l'affiche`,
    no_results: 'Aucune présentation ne correspond à votre recherche.',
  },
  schedule: {
    title: 'Horaire',
    no_schedule: `Il n'y a aucune session à montrer`,
    time_zone_details: `* Toutes les heures indiquées sont basées sur l'heure`,
    types: {
      postersession: `Session d'affiche`,
      keynote: 'Conférencier',
      oral: 'Orale',
      panel: 'Panel',
      workshop: 'Atelier',
      networking: 'Réseautage',
      break: 'Pause',
      other: 'Autre',
    },
    sign_to_access_room: 'Connectez-vous pour accéder à la salle',
    register_to_access_room: 'Inscrivez-vous pour accéder à la salle',
    back_to_list: 'Retour',
    only_participant_can_access_rooms: 'Seuls les participants inscrits peuvent accéder à la salle',
    live: 'En direct',
    now: 'Maintenant',
    virtual: 'Virtuel',
    minute_countdown: 'Dans {count} min',
    hour_countdown: 'Dans {count} heure | Dans {count} heures',
    day_countdown: 'Dans {count} jour | Dans {count} jours',
    tomorrow: 'Demain',
    cta_poster: "Aller à la salle d'affiches",
    cta_livestream: 'Rejoindre',
    presentation: {
      title: 'Présentations',
      show_all_in_presentations: 'Voir dans la page de présentations',
      no_results: "Il n'y a pas de présentation dans cette session.",
    },
    bookmark: 'Mettre en signet',
    unbookmark: 'Retirer le signet',
    bookmarked: 'Mis en signet',
    parallel_sessions: '{count} sessions parallèles',
  },
  conferencing: {
    conversation: {
      browser_limitation: `Le navigateur que vous utilisez ({browser}) n'est pas compatible.`,
    },
    confirm_quit: 'Vous êtes présentement dans un appel, voulez-vous vraiment quitter?',
    video_call_request_title: 'Demande de conversation',
    video_call_request_join: 'Joindre',
    video_call_request_decline: 'Refuser',
  },
  questions_and_answers: {
    acronym: 'Q&R',
    title: 'Posez une question',
    edit: 'Modifier',
    delete: 'Supprimer',
    presenter: 'Présentateur',
    reply_btn: 'Répondre',
    edit_btn: 'Modifier',
    cancel_btn: 'Annuler',
    submit_btn: 'Soumettre',
    textarea_message_placeholder: 'Votre question',
    textarea_reply_placeholder: 'Votre réponse',
    textarea_placeholder: 'Posez une question',
    success_message: {
      added: 'Le commentaire a été ajouté avec succès',
      updated: 'Le commentaire a été modifié avec succès',
      deleted: 'Le commentaire a été supprimé avec succès',
      delete_all: 'Les questions ont été supprimées avec succès',
    },
    must_be_logged_in: 'Vous devez être connecté pour interagir.',
    clear_messages: 'Effacer les questions',
    clear_messages_confirm: 'Voulez-vous vraiment effacer toutes les questions?',
  },
  hints: {
    payment_void:
      'Exonérer le paiement de cette transaction. Cette option est visible uniquement par les organisateurs.',
    payment_forward:
      '{firstName} ({email}) recevra une notification pour compléter le paiement. Cette option est visible uniquement aux organisateurs.',
  },
  testimonials: [
    {
      quote: `J'ai été extrêmement satisfaite de la plateforme et du service attentionné offert par l'équipe, qui comprend parfaitement les besoins organisationnels dans un cadre académique. Nous n'hésiterons pas à faire affaire avec Fourwaves.`,
      name: 'Nathalie Grandvaux',
      title: 'Professeure',
      organization_id: 'umontreal',
      organization_name: 'Université de Montréal',
    },
    {
      quote: `Un outil formidable, je ne sais pas comment je faisais avant! Fourwaves a diminué 85% de mon stress pour nos événements. J'apprécie la disponibilité et la rapidité à nous répondre.`,
      name: 'Joanne Auclair',
      title: 'Agente administrative',
      organization_id: 'crchum',
      organization_name: 'Centre de recherche du CHUM',
    },
    {
      quote: `Fourwaves élimine tous les irritants que l'organisateur rencontrera inévitablement, c'est-à-dire la gestion de l'inscription et des paiements, générant le programme final et les étiquettes de nom, la gestion du site web de l'événement, etc. C'est une plateforme essentielle!`,
      name: 'Nicolas Doucet',
      title: 'Chercheur',
      organization_id: 'inrs',
      organization_name: 'Institut national de la recherche scientifique',
    },
    {
      quote: `Nous utilisons couramment Fourwaves. En plus de la facilitée d'utilisation, la plateforme est particulièrement bien adaptée, efficace et surtout très fiable. Fourwaves constitue l'outil parfait pour sauver du temps et bien réussir dans l'organisation de nos événements.`,
      name: 'Pierre-Yves Savard',
      title: 'Coordonnateur de PROTEO',
      organization_id: 'ulaval',
      organization_name: 'Université Laval',
    },
    {
      quote: `J'utilise la plateforme Fourwaves depuis plusieurs années et j'en suis très satisfaite. C'est un outil qui facilite grandement le processus d'inscription ainsi que l'impression des badges et des livrets. L'équipe de Fourwaves est très dynamique et le support technique toujours très rapide.`,
      name: 'Annick Guyot',
      title: 'Associée de recherche',
      organization_id: 'mcgill',
      organization_name: 'Université McGill',
    },
    {
      quote: `Outil parfait pour l'organisation d'événement scientifique. Nous n'avons pas eu besoin de créer un site internet, tout est là sur le site de Fourwaves, même le créateur de cocarde qui nous a beaucoup aidé!`,
      name: 'Pierre Lavigne',
      title: 'Chercheur',
      organization_id: 'usherbrooke',
      organization_name: 'Université de Sherbrooke',
    },
    {
      quote: `Notre événement fût un succès entre autres grâce aux services de Fourwaves! L'équipe est toujours disponible pour aider au besoin et à l'écoute pour améliorer leur service. Je recommande à 100%!`,
      name: 'Hermance Beaud',
      title: 'Agente de soutien à la recherche',
      organization_id: 'uqam',
      organization_name: 'Université du Québec à Montréal',
    },
    {
      quote: `Notre conférence a été un grand succès et cela n'aurait pas été possible sans l'aide de Fourwaves. Le comité organisateur recommande vivement Fourwaves à tous ceux qui organisent des conférences.`,
      name: 'Calvin Yip',
      title: 'Professeur',
      organization_id: 'ubc',
      organization_name: 'Université de la Colombie-Britannique',
    },
    {
      quote: `J'ai organisé un symposium à l'aide de Fourwaves. La plateforme m'a permis de tout gérer sans effort. Je la recommande fortement pour tous vos besoins d'événements.`,
      name: 'Sylvie Lesage',
      title: 'Professeur titulaire',
      organization_id: 'umontreal',
      organization_name: 'Université de Montréal',
    },
    {
      quote: `La plateforme est superbe et fait en sorte que le Réseau de cancérologie de la Montérégie a grandement amélioré l'efficacité et le professionnalisme de son colloque.`,
      name: 'Chantal Keough',
      title: 'Coordonatrice',
      organization_id: 'cisss',
      organization_name: `CIUSSS du Centre-Sud-de-l'Île-de-Montréal`,
    },
    {
      quote: `Notre conférence a été un succès et Fourwaves a évité bien des maux de tête! Notre expérience a été exceptionnelle.`,
      name: 'Rodrigo Fernandez-Gonzalez',
      title: 'Professeur',
      organization_id: 'utoronto',
      organization_name: 'Université de Toronto',
    },
    {
      quote: `Le processus d'inscription s'est déroulé comme un charme, et Fourwaves m'a économisé beaucoup de temps pendant les derniers mois!`,
      name: 'Jean-Philippe Vézina',
      title: 'Professeur',
      organization_id: 'ulaval',
      organization_name: 'Université Laval',
    },
    {
      quote: `Nous recommandons Fourwaves sans hésitation, c'est une plateforme exceptionnelle.`,
      name: 'Chantale Bisson',
      title: 'Agente administrative',
      organization_id: 'cdrv',
      organization_name: 'Centre de Recherche sur le Vieillissement',
    },
    {
      quote: `Fourwaves permet un gain de temps considerable. Nous allons définitivement continuer à l'utiliser.`,
      name: 'Myriam Talantikit',
      title: 'Assistante administrative',
      organization_id: 'rimuhc',
      organization_name: 'Institut de recherche du CUSM',
    },
    {
      quote: `La plateforme est super simple d'utilisation et donne un look professionnel à notre événement!`,
      name: 'Kim Santerre',
      title: 'Étudiante au doctorat',
      organization_id: 'ulaval',
      organization_name: 'Université Laval',
    },
    {
      quote: `Une plateforme simple d'utilisation qui nous a sauvé énormément de temps pour les inscriptions et l'impression des badges et du livret. Fourwaves correspond très bien à nos besoins! Félicitations et un grand merci pour votre travail impeccable!`,
      name: 'Mylène Côté',
      title: 'Coordonnatrice académique',
      organization_id: 'usherbrooke',
      organization_name: 'Université de Sherbrooke',
    },
    {
      quote: `Fourwaves fournit une plateforme efficace avec une interface conviviale que tout le monde peut rapidement maîtriser. Pour nous, c'était une véritable bouée de sauvetage. Je ne peux pas imaginer organiser une conférence sans Fourwaves!`,
      name: 'Lynn Kamerlin',
      title: 'Professeure',
      organization_id: 'uppsala',
      organization_name: `Université d'Uppsala`,
    },
    {
      quote: `Fourwaves a rehaussé notre symposium à un niveau professionnel. L'interface  hautement personnalisable a permis d'économiser énormément de temps. Le support a répondu à nos questions rapidement. Fourwaves a été un outil essentiel à la réussite de notre événement.`,
      name: 'Jean-François Sauvageau',
      title: 'Coordonateur',
      organization_id: 'cbs',
      organization_name: 'La Société Canadienne des Biomatériaux',
    },
    {
      quote: `Je ne peux que féliciter Fourwaves pour leur professionnalisme dans le développement de cette solution clé en main, qui permet aux universitaires de se concentrer sur la science de l'événement. Je vous encourage vivement à utiliser Fourwaves.`,
      name: 'Rafael Najmanovich',
      title: 'Professeur',
      organization_id: 'umontreal',
      organization_name: 'Université de Montréal',
    },
    {
      quote: `Fourwaves est la plateforme idéale pour les organisateurs d'événements. Appréciée des participants, cela nous a fait gagner énormément de temps pour la Journée Phare 2012 et 2013. L'équipe Fourwaves était très réceptive à nos besoins. Un outil flexible et adaptable!`,
      name: 'Marc-Olivier Frégeau',
      title: 'Président',
      organization_id: 'phare',
      organization_name: 'Journée Phare',
    },
    {
      quote: `Je n'ai que de bons commentaires, facile à utiliser, hyper fonctionnel, tout est là! J'ai eu l'impression que la plateforme a été construite selon mes propres spécifications.`,
      name: 'Ninon Cardinal',
      title: 'Président',
      organization_id: 'safran',
      organization_name: 'Safran Événements',
    },
    {
      quote: `Fourwaves a été super pour gérer les résumés, les inscriptions, le livret, les cocardes, la promotion de l'événement. La plateforme a rendu très efficaces les différentes communications.`,
      name: 'Claudia Larochelle',
      title: 'Professionnelle de recherche',
      organization_id: 'ulaval',
      organization_name: 'Université Laval',
    },
    {
      quote: `Les inscriptions se sont très bien déroulées - nous n'avions rien à faire une fois la configuration terminée! Nous sommes très satisfaits du résultat.`,
      name: 'Natalie Goto',
      title: 'Professeure',
      organization_id: 'uottawa',
      organization_name: `Université d'Ottawa`,
    },
    {
      quote: `J'ai adoré travailler avec Fourwaves, tout a bien été pour les inscriptions et pour sortir les listes.`,
      name: 'Annie Caisse',
      title: 'Agente administrative',
      organization_id: 'chusj',
      organization_name: 'CHU Sainte-Justine',
    },
    {
      quote: `Utiliser Fourwaves pour la gestion d'événements scientifiques, majeurs ou plus petits est maintenant un indispensable pour notre organisation. L'interface est très facile à prendre en main, personnalisable et complète.`,
      name: 'Aline Dumas',
      title: 'Coordonnatrice aux événements',
      organization_id: 'ulaval',
      organization_name: 'Université Laval',
    },
    {
      quote: `La plateforme est conviviale et facile d'utilisation. L'équipe de Fourwaves offre également un support hors-pair. Ils sont réactifs et à l'écoute, ce qui facilite grandement notre travail d'organisateur!`,
      name: 'Fanny Toussaint',
      title: 'Gestionnaire de programme',
      organization_id: 'rimuhc',
      organization_name: 'Institut de recherche du CUSM',
    },
    {
      quote: `L'événement s'est super bien passé. On n'a vécu aucune difficulté technologique ni du côté des inscriptions ni du côté de la visioconférence de l'événement. On a vraiment beaucoup apprécié la plateforme.`,
      name: 'Rosalie Kott',
      title: 'Avocate',
      organization_id: 'cisss',
      organization_name: `CIUSSS du Centre-Sud-de-l'Île-de-Montréal`,
    },
    {
      quote: `Fourwaves a très bien fonctionné pour l'événement, et tout le monde semblait pouvoir y accéder facilement.`,
      name: 'Daphne Goring',
      title: 'Professeure',
      organization_id: 'utoronto',
      organization_name: 'Université de Toronto',
    },
    {
      quote: `L'aide de Fourwaves a été précieuse. Ça fait toute la différence dans l'organisation d'un événement virtuel. Nous avons reçu du feedback de participants qui ont beaucoup apprécié le format et la plateforme.`,
      name: 'Chantal Binda',
      title: 'Coordonatrice académique',
      organization_id: 'usherbrooke',
      organization_name: 'Université de Sherbrooke',
    },
    {
      quote: `Notre journée annuelle virtuelle a été un grand succès. Les participants ont aimé la possibilité de discuter avec les étudiants devant leurs affiches. Je n'ai eu que des bons commentaires sur Fourwaves.`,
      name: 'Friederike Pfau',
      title: 'Chargée de projet',
      organization_id: 'chuqul',
      organization_name: 'CHU de Québec-Université Laval',
    },
    {
      quote: `En résumé: j'ai adoré!! La session virtuelle des affiches de Fourwaves est une alternative A1 lorsque le présentiel est impossible. J'ai adoré les interactions. J'ai pu, de chez moi, parler avec tous les présentateurs d'affiche.`,
      name: 'Valérie Lavastre',
      title: 'Coordonnatrice',
      organization_id: 'rrsv',
      organization_name: 'Réseau de recherche en santé de la vision',
    },
    {
      quote: `Fourwaves a indéniablement contribué au franc succès de notre Colloque, nous a permis d'offrir, à l'ensemble de nos participants, un événement interactif d'une qualité professionnelle, et ce, à un tarif plus qu'abordable.`,
      name: 'Meghan Bergeron',
      title: 'Étudiante',
      organization_id: 'ulaval',
      organization_name: 'Université Laval',
    },
    {
      quote: `C'est une chose de vendre une solution et un service, c'en est une autre de satisfaire les clients. Je peux dire que Fourwaves a relevé le défi avec brio!`,
      name: 'Martin Guay',
      title: 'Conseiller en communication',
      organization_id: 'ulaval',
      organization_name: 'Université Laval',
    },
    {
      quote: `Nous avons vraiment apprécié Fourwaves. Merci beaucoup d'avoir fourni cette plateforme, c'était vraiment un moment fort de notre événement.`,
      name: 'Amber Leland',
      title: 'Directrice adjointe',
      organization_id: 'crcao',
      organization_name: 'Coordinating Research Council',
    },
    {
      quote: `Ça c'est super bien déroulé, les participants ont bien apprécié la plateforme et ses modalités!`,
      name: 'Sophie Aubé',
      title: `Auxiliaire d'enseignement`,
      organization_id: 'ulaval',
      organization_name: 'Université Laval',
    },
    {
      quote: `La session d'affiches virtuelle nous a aidés à garder l'esprit de l'événement et a été l'occasion de nombreuses conversations entre les participants et les présentateurs.`,
      name: 'David Bird',
      title: 'Professeur agrégé',
      organization_id: 'mtroyal',
      organization_name: 'Université Mount Royal',
    },
    {
      quote: `L'événement s'est très bien déroulé et les participants ont vraiment apprécié la plate-forme Fourwaves.`,
      name: 'Anna Duron',
      title: 'Assistant de programme',
      organization_id: 'uidaho',
      organization_name: 'University of Idaho',
    },
    {
      quote: `Le point culminant était la session d'affiche qui a permis des discussions en direct entre les participants. Fourwaves a très bien fonctionné avant, pendant et après la session d'affiches. Merci pour le support client solide.`,
      name: 'Emily Delgado',
      title: 'Directrice principale',
      organization_id: 'mskcc',
      organization_name: 'Memorial Sloan Kettering Cancer Center',
    },
    {
      quote: `Notre événement s'est très bien déroulé, autant pour les conférences que la séance poster. Merci beaucoup et bravo pour votre plateforme améliorée!`,
      name: 'Andree Lessard',
      title: 'Coordonatrice de réseau',
      organization_id: 'mcgill',
      organization_name: 'Université McGill',
    },
    {
      quote: `Fourwaves est une excellente plateforme. Je l'ai utilisé pour 2 événements et les deux étaient si faciles et j'ai également entendu beaucoup de compliments de la part des participants.`,
      name: 'Emilie Brown',
      title: 'Coordonatrice',
      organization_id: 'ysu',
      organization_name: 'Youngstown State University',
    },
    {
      quote: `La conférence s'est très bien déroulée et tout le monde a été satisfait de la plateforme. Merci !`,
      name: 'Cécile Berne',
      title: 'Associée de recherche',
      organization_id: 'umontreal',
      organization_name: 'Université de Montréal',
    },
    {
      quote: `Grâce à Fourwaves, notre école doctorale a pu organiser sa journée des doctorants, avec deux séances posters virtuelles. Les échanges autours des posters ont été très appréciés, nous remercions Fourwaves!`,
      name: 'Marie-Hélène Berger',
      title: 'Directrice de recherche',
      organization_id: 'mpt',
      organization_name: 'École des Mines de Paris',
    },
    {
      quote: `J'apprécie vraiment la réactivité et l'efficacité de l'équipe. La plateforme fonctionne super bien, merci encore.`,
      name: 'Evelyne Muhire',
      title: 'Coordonatrice',
      organization_id: 'umontreal',
      organization_name: 'Université de Montréal',
    },
    {
      quote: `Je tenais à remercier Fourwaves pour le service impeccable et personnalisé que nous avons reçu. La plateforme et les réponses claires et rapides des membres de l'équipe ont très certainement contribué au succès de notre événement.`,
      name: 'Pauline Claude',
      title: 'Professionnelle de recherche',
      organization_id: 'crispesh',
      organization_name: 'CRISPESH',
    },
    {
      quote: `J'ai aimé l'expérience sur Fourwaves pour l'événement en ligne du 42e symposium. J'ai eu de bons feedback des conférenciers et des participants.`,
      name: 'Kapinga Kalala',
      title: 'Coordonnatrice',
      organization_id: 'umontreal',
      organization_name: 'Université de Montréal',
    },
    {
      quote: `L'expérience Fourwaves a été concluante pour nos Journées de la recherche de la Faculté de médecine et des centres de recherche affiliés de l'Université Laval. L'approche personnalisée et l'écoute des besoins de l'équipe Fourwaves sont des valeurs ajoutées.`,
      name: 'Louise Laperrière',
      title: 'Adjointe au Vice-doyen',
      organization_id: 'ulaval',
      organization_name: 'Université Laval',
    },
    {
      quote: `Pratique. Simple. Professionnel En tant que coordinatrice, j'ai pleinement confiance dans le fonctionnement et le professionnalisme de la plateforme. Chaque fois, nos clients rapportent qu'elle est intuitive et facile à naviguer. De plus, le personnel de Fourwaves a toujours été très courtois, serviable et réactif.`,
      name: 'Brieanna Wright',
      title: 'Coordonatrice',
      organization_id: 'lbl',
      organization_name: 'Laboratoire national Lawrence-Berkeley',
    },
  ],
});
